module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Export-ddb7ffe118fe793b15397561432a9c78.svg";